export default __webpack_public_path__ + "static/media/salad-dish.7cc8ec88.jpg";